const dateLocale = require('date-fns/locale/it');

export default {
  dateLocale,
  dateFormatReadable: 'dddd DD/MM',
};
